import { Stack } from 'expo-router';

export default function OrgInviteLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
